import { createAPIModule } from 'utility/redux/apiModuleHelpers';

const getStateSlice = (state) => state.api.billing.payment.make;

const {
	actions,
	reducer,
	sagas,
	selectors: defaultSelectors,
} = createAPIModule({
	getStateSlice,
	actionType: 'BILLING_PAYMENT_MAKE',
	url: '/billing/payment/make.json',
});

const selectors = {
	...defaultSelectors,
};

export { actions, reducer, sagas, selectors };
